import React from 'react';
import { Button, Modal } from 'react-bootstrap';

interface SamplingRulesModalProps {
	show: boolean;
	onHide: () => void;
	name: string;
	description: string;
}

const SamplingRulesModal: React.FC<SamplingRulesModalProps> = ({ show, onHide, name, description }) => {
	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header>
				<Modal.Title>Regole di campionamento del bando</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<span className="new-subtitle f-24">
					{name}
					{/* {project?.samplingRuleAssignment?.samplingRule?.name} */}
				</span>
				<span className="d-block mt-2">
					{description}
					{/* {project?.samplingRuleAssignment?.samplingRule?.description} */}
				</span>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onHide} className="btn custom-outline-button">
					Chiudi
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default SamplingRulesModal;
